import { ObjectsView } from "@organisms"

import { VENDOR_ROUTES } from "@routes/vendor"

export const VendorObjectsViewTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_active"
            phase="active"
            title="All Active"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["ordering", "name"],
                ["is_active", "true"],
            ]}
            listEndpoint={VENDOR_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={VENDOR_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_inactive"
            phase="inactive"
            title="All Inactive"
            endpointKwargs={[
                ["ordering", "name"],
                ["is_active", "false"],
            ]}
            listEndpoint={VENDOR_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={VENDOR_ROUTES.COUNT}
            isDefaultActiveTabForPhase={true}
        />
    </ObjectsView.Tabs>
)
